import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { FundTypeEnum, GoldTypeEnum, MetalTypeEnum } from '~utils/enums';

export default function* watchGetSettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetSettingsAttempt', handleGetSettings, api);
}

function* handleGetSettings(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const { index, filters: { productName, fundType, goldType, metalType } } = state.setting.settings;

    if (!index && index !== 0) {
        yield put(combinedActions.settingGetSettingsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getSettings], {
        authToken,
        index,
        productName: productName || undefined,
        fundType: fundType ? FundTypeEnum[fundType as keyof typeof FundTypeEnum] : undefined,
        goldType: goldType ? GoldTypeEnum[goldType.replace(/\s+([A-Z])/g, (_, letter) => letter) as keyof typeof GoldTypeEnum] : undefined,
        metalType: metalType ? MetalTypeEnum[metalType as keyof typeof MetalTypeEnum] : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetSettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetSettingsSuccess(response.data));
    }
}
